/**
 * `payments` — les règlements (base galerie, 4.1).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, centimesSchema, deviseSchema, idSchema, withAudit } from './commun.js';
export const MODES_REGLEMENT = ['virement', 'carte', 'cheque', 'especes', 'autre'];
export const modeReglementSchema = z.enum(MODES_REGLEMENT);
export const paymentSchema = withAudit(z.object({
    _id: idSchema,
    factureId: idSchema,
    montantCentimes: centimesSchema,
    devise: deviseSchema.default('EUR'),
    mode: modeReglementSchema,
    date: z.date(),
    reference: z.string().optional(),
    note: z.string().optional(),
}));
export const paymentCreationSchema = paymentSchema.omit(CHAMPS_DOCUMENT);
export const paymentMiseAJourSchema = paymentCreationSchema.omit({ factureId: true }).partial();
//# sourceMappingURL=payments.js.map